<template>
  <div>
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/tokenPackage/tokenPackageAddThree')"
    >
      新增
    </a-button>
    <a-button type="danger" :style="{ margin: '0 0 24px 0' }" @click="dels">
      批量删除
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-selection="rowSelection"
      >4/5000

      <template slot="surfacePlot" slot-scope="text">
        <img style="width: 110px; height: 60px" :src="text" alt="" />
      </template>
      <a-avatar slot="avatar" icon="user" />
      <span slot="memberStatus" slot-scope="text, record">
        <a-switch
          checked-children="开启"
          un-checked-children="未开启"
          :checked="record.isApply === 1 ? true : false"
          @change="onChange(record)"
        />
      </span>
      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/eventManagement/registrationDetailsHome?objId=${operate.objId}`
            )
          "
          >报名详情</a
        >
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/tokenPackage/tokenPackageEditThree?id=${operate.objId}`
            )
          "
          >编辑</a
        >
        <a @click="del(operate)">删除</a>
        <a @click="pushMes(operate)">信息推送</a>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { ManageList, delManageList, storeActivity, mesPush } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "主图",
    dataIndex: "surfacePlot",
    sorter: true,
    scopedSlots: { customRender: "surfacePlot" },
  },
  {
    title: "活动标题",
    dataIndex: "activityTitle",
  },
  {
    title: "活动门店",
    dataIndex: "activityContent",
  },
  {
    title: "开始时间",
    dataIndex: "startTime",
    sorter: true,
    scopedSlots: { customRender: "startTime" },
  },
  {
    title: "结束时间",
    dataIndex: "endTime",
    sorter: true,
    scopedSlots: { customRender: "endTime" },
  },
  {
    title: "活动状态",
    dataIndex: "name",
    sorter: true,
    scopedSlots: { customRender: "memberStatus" },
  },
  {
    title: "显示顺序",
    dataIndex: "sortNum",
    sorter: true,
    scopedSlots: { customRender: "sortNum" },
  },
  {
    title: "发布时间",
    dataIndex: "startTime",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    width: 200,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getManageList();
  },
  props: ["formInline"],
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.$store.commit("setidList", selectedRowKeys);
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
        },
      };
    },
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      ManageList({ limit: 10, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    getManageList() {
      ManageList({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    del(row) {
      this.loading = true;
      console.log(row);
      delManageList([row.objId]).then((res) => {
        this.loading = false;
        this.getManageList();
        message.success(res.data);
      });
    },
    pushMes(row) {
      this.loading = true;
      mesPush(row.objId, 4).then((res) => {
        this.loading = false;
        message.success(res.data);
      })
    },
    dels() {
      let idList = this.$store.state.idList;
      delManageList(idList).then((res) => {
        this.getManageList();
        message.success("删除成功");
      });
    },
    query() {
      this.loading = true;
      ManageList(this.formInline).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    onChange(row) {
      console.log(row);
      if (row.isApply === 1) {
        storeActivity({ id: row.objId, isApply: 0 }).then(() => {
          this.getManageList();
          message.success(res.info);
        });
      }
      if (row.isApply === 0) {
        storeActivity({ id: row.objId, isApply: 1 }).then(() => {
          this.getManageList();
          message.success(res.info);
        });
      }
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/eventManagement/eventManagementHomeContent.vue